import { ElementType } from 'react';

import {
  LuFile,
  LuInbox,
  LuMails,
  LuMessageCircle,
  LuOctagonAlert,
  LuSend,
  LuTrash2,
} from 'react-icons/lu';

import {
  INSTAGRAM_TAB_PARAM,
  InstagramConversationType,
} from '../../../../models';
import { APP_PAGES } from '../../../../routes/constants';
import { MirroredTagsIcon } from '../../../MirroredTagsIcon';
import { useInboxCount } from '../../hooks';
import { InboxType } from '../../types';
import { SidebarNavLink } from '../SidebarNavLink';

interface InboxNavLinkProps {
  type: InboxType;
  isOpen: boolean;
  onNavigate?: () => void;
  showCounter?: boolean;
}

interface InboxConfig {
  href: string;
  icon: ElementType;
  labelKey: string;
}

const getInboxConfig = (type: InboxType): InboxConfig => {
  const configs: Record<InboxType, InboxConfig> = {
    main: {
      href: APP_PAGES.INBOX,
      icon: LuInbox,
      labelKey: 'inbox.sidebar.main',
    },
    sent: {
      href: APP_PAGES.INBOX_SENT,
      icon: LuSend,
      labelKey: 'inbox.sidebar.sent',
    },
    draft: {
      href: APP_PAGES.INBOX_DRAFT,
      icon: LuFile,
      labelKey: 'inbox.sidebar.draft',
    },
    labels: {
      href: APP_PAGES.INBOX_LABELS,
      icon: MirroredTagsIcon,
      labelKey: 'inbox.sidebar.labels',
    },
    all: {
      href: APP_PAGES.INBOX_ALL,
      icon: LuMails,
      labelKey: 'inbox.sidebar.all',
    },
    spam: {
      href: APP_PAGES.INBOX_SPAM,
      icon: LuOctagonAlert,
      labelKey: 'inbox.sidebar.spam',
    },
    trash: {
      href: APP_PAGES.INBOX_TRASH,
      icon: LuTrash2,
      labelKey: 'inbox.sidebar.trash',
    },
    'slack-directs': {
      href: `${APP_PAGES.SLACK_INBOX_OVERVIEW}?tab=directs`,
      icon: LuInbox,
      labelKey: 'inbox.sidebar.dm',
    },
    'slack-channels': {
      href: `${APP_PAGES.SLACK_INBOX_OVERVIEW}?tab=channels`,
      icon: LuMessageCircle,
      labelKey: 'inbox.sidebar.channels',
    },
    'teams-chats': {
      href: `${APP_PAGES.TEAMS_INBOX_OVERVIEW}?tab=chats`,
      icon: LuInbox,
      labelKey: 'inbox.sidebar.chats',
    },
    'instagram-dms': {
      href: `${APP_PAGES.INSTAGRAM_INBOX_OVERVIEW}?${INSTAGRAM_TAB_PARAM}=${InstagramConversationType.DM}`,
      icon: LuInbox,
      labelKey: 'inbox.sidebar.dm',
    },
  };

  return configs[type];
};

export const InboxNavLink = ({
  type,
  isOpen,
  onNavigate,
  showCounter,
}: InboxNavLinkProps) => {
  const { count, isPartial } = useInboxCount(type);
  const config = getInboxConfig(type);

  return (
    <SidebarNavLink
      icon={config.icon}
      text={config.labelKey}
      href={config.href}
      isOpen={isOpen}
      count={count}
      isPartial={isPartial}
      showCounter={showCounter}
      onNavigate={onNavigate}
    />
  );
};
